import { render, staticRenderFns } from "./AddChemicals.vue?vue&type=template&id=b92f50ba"
import script from "./AddChemicals.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddChemicals.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports